module.exports = __webpack_public_path__ + "static/media/logo_exmimbank.839ad4cc.svg";